import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import format from "date-fns/format";
import { useDetailContext } from "@/context/detailContext";
import tr from "date-fns/locale/tr";
import { useSearchParams } from "next/navigation";
import useClickOutside from "@/hooks/useClickOutside";
import dynamic from "next/dynamic";

const DateRangeSelectorAnimated = dynamic(
  () => import("./DateRangeSelectorAnimated"),
  {
    ssr: false,
  }
);

const DateRangeSelector = ({
  showCalendar,
  setShowCalendar,
  dates,
  setError,
}) => {
  const searchParams = useSearchParams();
  const refCalendarVilla = useRef(null);
  const refTwo = useRef(null);

  const { selectedDatesFilter, setSelectedDatesFilter } = useDetailContext();
  const { startDate, endDate } = selectedDatesFilter[0] || {};

  const [dayStart, setdayStart] = useState(format(startDate, "dd"));
  const [dayEnd, setdayEnd] = useState(format(endDate, "dd"));

  const [doluGirisler, setDoluGirisler] = useState([]);
  const [doluCikislar, setDoluCikislar] = useState([]);
  const [doluGunler, setDoluGunler] = useState([]);
  const [odemeGirisler, setOdemeGirisler] = useState([]);
  const [odemeCikislar, setOdemeCikislar] = useState([]);
  const [odemeGunler, setOdemeGunler] = useState([]);
  const [isShow, setIsShow] = useState(false);

  const [monthStart, setmonthStart] = useState(
    format(startDate, "MMM", { locale: tr })
  );
  const [monthEnd, setmonthEnd] = useState(
    format(endDate, "MMM", { locale: tr })
  );

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };
  function CloseToggle() {
    setShowCalendar(false);
  }
  function onChange(item) {
    setSelectedDatesFilter([item.selection]);
    setError(false);
    if (item.selection.startDate !== item.selection.endDate) {
      CloseToggle();
    }
  }
  function customDayContent(day) {
    let classname = null;
    if (
      doluGirisler?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0 &&
      doluCikislar?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "doluGirdiCikti";
    } else if (
      doluGunler?.filter((x) => day.toDateString() == x.toDateString()).length >
      0
    ) {
      classname = "doluGunler";
    } else if (
      doluCikislar?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "doluCikis";
    } else if (
      doluGirisler?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "doluGiris";
    } else if (
      odemeGirisler?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "odemeGiris";
    } else if (
      odemeCikislar?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "odemeCikis";
    } else if (
      odemeGunler?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "odemeGunler";
    }
    return (
      <div className={`absolute inset-0 ${classname}`}>
        <span className="text-white">{format(day, "d")}</span>
      </div>
    );
  }
  useEffect(() => {
    setDoluGunler(dates?.doluGunler?.map((e) => new Date(e)));
    setDoluGirisler(dates?.doluGirisler?.map((e) => new Date(e)));
    setDoluCikislar(dates?.doluCikislar?.map((e) => new Date(e)));
    setOdemeGunler(dates?.odemeGunler?.map((e) => new Date(e)));
    setOdemeGirisler(dates?.odemeGirisler?.map((e) => new Date(e)));
    setOdemeCikislar(dates?.odemeCikislar?.map((e) => new Date(e)));
  }, [dates]);

  useEffect(() => {
    setdayStart(format(startDate, "dd"));
    setdayEnd(format(endDate, "dd"));
    setmonthStart(format(startDate, "MMM", { locale: tr }));
    setmonthEnd(format(endDate, "MMM", { locale: tr }));
  }, [startDate, endDate, tr]);

  // searchParams varsa reservatsyon formuna scroll ediyor

  useEffect(() => {
    const startDate = searchParams.get("start");
    const endDate = searchParams.get("end");

    if (startDate && endDate) {
      setTimeout(() => {
        if (refCalendarVilla.current) {
          refCalendarVilla.current.scrollIntoView({
            behavior: "smooth",
            block: "start", // Alt kısmı görünür yap
            inline: "nearest",
          });
        }
      }, 100);
    }
  }, [searchParams]);

  useClickOutside([refCalendarVilla, refTwo], CloseToggle);
  return (
    <div className="relative flex flex-col w-full">
      <button
        ref={refCalendarVilla}
        // onClick={ToggleShow}
        onClick={toggleCalendar}
        className="w-full flex items-center cursor-pointer rounded border border-[#E7EDF4] bg-white py-4 px-5"
      >
        <div className="flex items-center gap-5">
          <span className="text-sm font-medium leading-normal text-themeBreadcrumColor">
            {endDate > startDate
              ? `${dayStart} - ${monthStart}`
              : "Tarih Seçiniz"}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="#303C42"
          >
            <path
              d="M11.9305 6.32L9.26388 3.8894C9.18979 3.82923 9.1088 3.81765 9.02082 3.8547C8.93294 3.89179 8.88882 3.95887 8.88882 4.05614V5.61171H0.222217C0.157371 5.61171 0.104103 5.6325 0.0624863 5.67417C0.0208936 5.71581 0 5.76908 0 5.83387V7.16718C0 7.23195 0.0207963 7.28522 0.062462 7.32681C0.104176 7.36845 0.157444 7.38925 0.222193 7.38925H8.88887V8.94479C8.88887 9.03751 8.93306 9.10459 9.02089 9.14614C9.10894 9.18333 9.18994 9.16927 9.26403 9.10459L11.9306 6.64608C11.9769 6.59981 12 6.54436 12 6.47949C12 6.41946 11.9768 6.36629 11.9305 6.32Z"
              fill="#303C42"
              fillOpacity="0.3"
            />
          </svg>
          <span className="text-sm font-medium leading-normal text-themeBreadcrumColor">
            {endDate > startDate ? `${dayEnd} - ${monthEnd}` : "Tarih Seçiniz"}
          </span>
        </div>
        <Image
          src="/icons/calendar.svg"
          width={24}
          height={24}
          alt="calendar"
          className="ml-auto"
        />
      </button>
      {showCalendar && (
        <DateRangeSelectorAnimated
          refTwo={refTwo}
          setIsShow={setIsShow}
          selectedDatesFilter={selectedDatesFilter}
          refCalendarVilla={refCalendarVilla}
          customDayContent={customDayContent}
          onChange={onChange}
          doluGunler={doluGunler}
          toggleCalendar={toggleCalendar}
        />
      )}
    </div>
  );
};

export default DateRangeSelector;
